import React, { useEffect, useState } from "react";
import {
  DataGrid,
  Column,
  Scrolling,
  ColumnFixing,
  FilterRow,
  FilterPanel,
  HeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react/data-grid";
import CommentRenderer from "./CommentRenderer";
import { api_path } from "../../shared.js";
import Box from "@mui/material/Box";
export default function MentionedCommentsBox({ userId }) {
  const [comments, setComments] = useState([]);
  useEffect(() => {
    fetch(`${api_path}/customer/get-mention.php?userId=${userId}`)
      .then((res) => res.json())
      .then((data) => setComments(data))
      .catch((err) => console.error("Error fetching mentions:", err));
  }, [userId]);

  const onCommentButtonClick = (CRM_CUSCODE, SALES_ACTIVITY_ITEM_ID) => {
    // 1) เปิดหน้า customer
    const url = `/s-crm/customer?customer_id=${CRM_CUSCODE}`;
    window.open(url, "_blank", "noopener,noreferrer");

    // 2) ยิง API update is_read
    fetch(api_path + "/customer/update-isread.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sales_activity_item_id: SALES_ACTIVITY_ITEM_ID,
        is_read: 1,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          // ✅ ลบออกจาก state
          // setComments((prev) =>
          //   prev.filter(
          //     (c) => c.SALES_ACTIVITY_ITEM_ID !== SALES_ACTIVITY_ITEM_ID
          //   )
          // );
        } else {
          console.error("Update failed:", data.message);
        }
      })
      .catch((error) => console.error("Error updating IS_READ:", error));
  };

  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">📣 Mentions</h5>
      {/* {comments.length === 0 ? (
        <p className="text-sm text-gray-400">No mentions</p>
      ) : ( */}
      <Box sx={{ maxHeight: 310, overflow: "auto" }}>
        <DataGrid
          dataSource={comments}
          keyExpr="SALES_ACTIVITY_ITEM_ID"
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          height={500}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={false} />
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true} />

          {/* Comment column */}
           <Column
            dataField="SALES_ACTIVITY_ITEM_ID"
visible={false}
          />
          <Column
            dataField="COMMENT"
            caption="Comment"
            cellRender={({ data }) => (
              <CommentRenderer comment={data.COMMENT} />
            )}
          />
          <Column
            caption="Info"
            cellRender={({ data }) => (
              <span>
                by {data.CreateName} on{" "}
                {new Date(data.CREATE_DATE).toLocaleString()}
              </span>
            )}
          />

          {/* View button */}
          <Column type="buttons" width={80}>
            <Button
              hint="View"
              text="View"
              onClick={(e) =>
                onCommentButtonClick(
                  e.row.data.CRM_CUSCODE,
                  e.row.data.SALES_ACTIVITY_ITEM_ID
                )
              }
            />
          </Column>
          <Column dataField="IS_READ" caption="IS_READ" />
        </DataGrid>
      </Box>
      {/* )} */}
    </div>
  );
}
